module.exports = __webpack_public_path__ + "static/pB4-5832213c15e2e794afa050c318cdc80c.png";